import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import { media } from "../styles/Mixin";

const Text = styled.span`
  ${media.deskTop`
    width:20px;
    height:20px;
    font-size:${(props) => props.theme.deskFontSize};
  `}
  ${media.mobile`
    width:10px;
    height:10px;
    font-size:${(props) => props.theme.mobileFontSize};
  `}
  border-radius:50%;
  background-color: ${(props) => props.theme.lightBlueColor};
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;

const CircleNumber = ({ number, className, onClick }) => (
  <Text className={className} onClick={onClick}>
    {number <= 100 ? number : 100+"+"}
  </Text>
);

CircleNumber.propTypes = {
  number: PropTypes.number.isRequired,
};

export default CircleNumber
